// extracted by mini-css-extract-plugin
export default {"page-loader-context":"page-loader-context_page-loader-context__O1uy9"};